import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const CRMDashboard = lazy(() => import('./CRMDashboard'));
const Customers = lazy(() => import('./Customers'));
const Leads = lazy(() => import('../Admin/Leads'));
const Opportunities = lazy(() => import('./Opportunities'));
const SupportTickets = lazy(() => import('./SupportTickets'));
const TicketDetail = lazy(() => import('./TicketDetail'));
const Activities = lazy(() => import('./Activities'));
const LoyaltyManagement = lazy(() => import('./LoyaltyManagement'));
const CommissionAgents = lazy(() => import('./CommissionAgents'));

export const crmRoutes = (
    <React.Fragment key="crm">
        <Route element={<ProtectedRoute permission="crm.customer.view" />}>
            <Route path="/crm/dashboard" element={<CRMDashboard />} />
            <Route path="/crm/customers" element={<Customers />} />
            <Route path="/crm/contacts" element={<Customers />} />
        </Route>
        <Route element={<ProtectedRoute permission="crm.opportunity.view" />}>
            <Route path="/crm/leads" element={<Leads />} />
            <Route path="/crm/opportunities" element={<Opportunities />} />
        </Route>
        <Route element={<ProtectedRoute permission="crm.ticket.view" />}>
            <Route path="/crm/tickets" element={<SupportTickets />} />
            <Route path="/crm/tickets/:id" element={<TicketDetail />} />
        </Route>
        <Route element={<ProtectedRoute permission="crm.activity.view" />}>
            <Route path="/crm/activities" element={<Activities />} />
        </Route>
        <Route element={<ProtectedRoute permission="loyalty.program.view" />}>
            <Route path="/loyalty-management" element={<LoyaltyManagement />} />
        </Route>
        <Route element={<ProtectedRoute permission="crm.commission_agent.view" />}>
            <Route path="/commission-agents" element={<CommissionAgents />} />
        </Route>
    </React.Fragment>
);
